import {useState} from 'react'
import {MenuButton, MenuProvider, useDialogStore} from '@ariakit/react'
import {Button} from '@/components/ui/button/Button'
import {DotsVerticalIcon, PlusIcon} from '@/components/ui/icon/Icon'
import {Menu, MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {useTranslation} from '@/translations/i18n'
import {CreateAccessDialog} from '@/features/accesses/components/create-access-dialog/CreateAccessDialog'
import {CreateAbsenceDialog} from '@/features/accesses/components/create-absence-dialog/CreateAbsenceDialog'

export const AddAccessAbsenceMenu = () => {
    const {t} = useTranslation()
    const [isOpen, setOpen] = useState(false)
    const createAbsenceDialogStore = useDialogStore()
    const createAccessDialogStore = useDialogStore()

    return (
        <MenuProvider open={isOpen} setOpen={setOpen}>
            <MenuButton
                render={
                    <Button variant="secondary" size="sm" shape="square">
                        <DotsVerticalIcon />
                    </Button>
                }
            />
            <Menu width="220px">
                <MenuItem onClick={() => createAbsenceDialogStore.setOpen(true)}>
                    <PlusIcon />
                    {t('accesses:add_absence')}
                </MenuItem>
                <MenuItem onClick={() => createAccessDialogStore.setOpen(true)}>
                    <PlusIcon />
                    {t('accesses:add_access')}
                </MenuItem>
            </Menu>
            <CreateAbsenceDialog dialogStore={createAbsenceDialogStore} />
            <CreateAccessDialog dialogStore={createAccessDialogStore} />
        </MenuProvider>
    )
}
